// header-lite.ts
// Tiny HEAD probe to show we can read selected headers. Emits single-object messages.

import { emit } from "../core/events";
import type { HeadersCheckedDetail, HeadersErrorDetail } from "../types";

type MsgChecked = HeadersCheckedDetail;
type MsgError = HeadersErrorDetail;

const WATCH = [
  "content-security-policy",
  "permissions-policy",
  "referrer-policy",
  "x-content-type-options",
  "strict-transport-security",
  "cache-control",
  "etag",
];

function toRecord(headers: Headers) {
  const out: Record<string, string> = {};
  headers.forEach((v, k) => {
    out[k.toLowerCase()] = v;
  });
  return out;
}

export async function checkHeadersLite(endpoint?: string) {
  try {
    const url = endpoint || location.href;
    const res = await fetch(url, {
      method: "HEAD",
      cache: "no-store",
      credentials: "same-origin",
      headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
    });
    const all = toRecord(res.headers);
    const picked: Record<string, string | undefined> = {};
    for (const k of WATCH) picked[k] = all[k];

    const msg: MsgChecked = {
      url,
      status: res.type === "opaque" ? "opaque" : res.status,
      headers: picked,
      ts: Date.now(),
    };
    emit({ type: "headers.checked", data: msg });
  } catch (e: any) {
    const err: MsgError = {
      message: String(e?.message || e),
      ts: Date.now(),
    };
    emit({ type: "headers.error", data: err });
  }
}
